import React from 'react';
import ToolbarButton from './ToolbarButton';
import ToolbarIconButton from './ToolbarIconButton';

/**
 * 복잡한 툴팁을 가진 툴바 버튼 컴포넌트
 * @param {Object} props
 * @param {React.ReactNode} props.children - 버튼 내용
 * @param {React.ReactNode} props.tooltip - 툴팁 내용 (JSX 가능)
 * @param {boolean} props.showTooltip - 툴팁 표시 여부
 * @param {string} props.tooltipPosition - 툴팁 위치 ('top', 'bottom', 'left', 'right')
 * @param {Object} props.buttonProps - ToolbarButton에 전달할 나머지 속성들
 */
const ToolbarButtonWithTooltip = ({
  children,
  tooltip,
  showTooltip = true,
  tooltipPosition = 'bottom',
  ...buttonProps
}) => {
  if (!showTooltip || !tooltip) {
    return <ToolbarButton {...buttonProps}>{children}</ToolbarButton>;
  }

  const positionClasses = {
    top: 'bottom-full left-1/2 transform -translate-x-1/2 mb-2',
    bottom: 'top-full left-1/2 transform -translate-x-1/2 mt-2',
    left: 'right-full top-1/2 transform -translate-y-1/2 mr-2',
    right: 'left-full top-1/2 transform -translate-y-1/2 ml-2'
  };

  const arrowClasses = {
    top: 'top-full left-1/2 transform -translate-x-1/2 border-4 border-transparent border-t-gray-800',
    bottom: 'bottom-full left-1/2 transform -translate-x-1/2 border-4 border-transparent border-b-gray-800',
    left: 'left-full top-1/2 transform -translate-y-1/2 border-4 border-transparent border-l-gray-800',
    right: 'right-full top-1/2 transform -translate-y-1/2 border-4 border-transparent border-r-gray-800'
  };

  return (
    <div className="relative group">
      <ToolbarButton {...buttonProps}>
        {children}
      </ToolbarButton>
      
      <div className={`
        absolute ${positionClasses[tooltipPosition]} 
        px-3 py-2 bg-gray-800 text-white text-xs rounded-md 
        opacity-0 group-hover:opacity-100 transition-opacity duration-200 
        pointer-events-none z-10 min-w-[280px] whitespace-normal
      `} style={{ lineHeight: '1.4' }}>
        {tooltip}
        <div className={`absolute ${arrowClasses[tooltipPosition]}`}></div>
      </div>
    </div>
  );
};

export default ToolbarButtonWithTooltip;
